<template>
    <el-row>
        
        <h3>修改密码</h3>

        <el-col :span="12" style="width:400px; margin-top:32px;">
            <el-form :model="form" ref="form" :rules="rules" label-width="100px">
                <el-form-item label="原密码" prop="OldPassword">
                    <el-input v-model="form.OldPassword" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="Passowrd">
                    <el-input v-model="form.Passowrd" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="ConfirmPassowrd">
                    <el-input v-model="form.ConfirmPassowrd" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="onSubmit">确认修改</el-button>
                </el-form-item>
            </el-form>
        </el-col>

    </el-row>
</template>


<script>
export default {
    data() {

        //复杂验证方式（确认新密码）
        var validConfirmPassowrd = (rule, value, callback) => {
            if (value !== this.form.Passowrd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };

        return {
            //定义form与默认值
            form: {
                OldPassword: '',
                Passowrd: '',
                ConfirmPassowrd: ''
            },
            //定义验证
            rules: {
                OldPassword: [
                    { required: true, message: '请输入当前密码', trigger: 'blur' }
                ],
                Passowrd: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, message: '请输入至少6位字符', trigger: 'blur' }
                ],
                ConfirmPassowrd: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { validator: validConfirmPassowrd, trigger: 'blur' }
                ],

            }
        }
    },
    methods: {
        onSubmit() {
            //form 验证
            this.$refs.form.validate((valid) => {

                if (valid) {

                    //接口请求
                    this.Data.Admin.ChangePassword(this.form.OldPassword, this.form.Passowrd).then(res => {

                        if (res.code == 0) {
                            this.form.OldPassword = '';
                            this.form.Passowrd = '';
                            this.form.ConfirmPassowrd = '';
                        }
                        else {
                            //element ui 默认注册的消息提示
                            this.$message.error(res.message);
                        }

                    })
                }

            });
        }
    }
}
</script>